import type { AxiosProgressEvent } from 'axios'

import { injectCompanyToURL } from '@helpers'

import Api from '../api'
import type { RemoveOnboardingDocumentPayload } from './types'
import { API_ONBOARDING_DOCUMENT_URL, API_ONBOARDING_DOCUMENTS_URL } from './urls'

export function fetchOnboardingDocuments(companyId: Company['id']) {
  return Api.get<BackendCompanyDocument[]>(injectCompanyToURL(API_ONBOARDING_DOCUMENTS_URL, companyId))
}

export function uploadOnboardingDocument(
  companyId: Company['id'],
  file: File,
  onUploadProgress?: (event: AxiosProgressEvent) => void
) {
  return Api.post<BackendCompanyDocument>(
    injectCompanyToURL(API_ONBOARDING_DOCUMENTS_URL, companyId),
    { document: file },
    {
      onUploadProgress,
      timeout: 5 * 60000, // 5 * 60sec
      transformRequest: [
        function (data) {
          const formData = new FormData()
          formData.append('document', data.document)
          return formData
        },
      ],
    }
  )
}

export function removeOnboardingDocument(companyId: Company['id'], { documentId }: RemoveOnboardingDocumentPayload) {
  return Api.delete(
    injectCompanyToURL(API_ONBOARDING_DOCUMENT_URL, companyId).replace('{document_id}', String(documentId))
  )
}
